const SEARCH_PAGE_WEBTREKK_INFO = 'SearchPage';
const SEARCH_WEBTREKK_INFO = 'Search';
const SEARCH_MIN_QUERY_LENGTH = 1;

const SEARCH_PAGE_DOUBLE_COLUMN_IMG_SIZE = '300-443';
const SEARCH_PAGE_SINGLE_COLUMN_IMG_SIZE = '400-596';

const IGNORE_TOLKIEN_QUERY_PARAM = {
  KEY: 'i',
  VALUE: 't',
}

const IGNORE_TYPO_QUERY_PARAM = {
  KEY: 'it',
  VALUE: 't',
}

const IGNORE_GENDER_QUERY_PARAM = {
  KEY: 'ig',
  VALUE: 't',
}

const IGNORE_COLOR_QUERY_PARAM = {
  KEY: 'ico',
  VALUE: 't',
}

const SEARCH_TERM_TYPO_SUGGESTIONS_DECISIONS = {
  OVERRIDE: 'override',
  SUGGEST: 'suggest',
  VALID: 'valid',
  IGNORE: 'ignore',
}

export {
  SEARCH_PAGE_WEBTREKK_INFO,
  SEARCH_WEBTREKK_INFO,
  SEARCH_MIN_QUERY_LENGTH,
  SEARCH_PAGE_DOUBLE_COLUMN_IMG_SIZE,
  SEARCH_PAGE_SINGLE_COLUMN_IMG_SIZE,
  IGNORE_TOLKIEN_QUERY_PARAM,
  IGNORE_TYPO_QUERY_PARAM,
  IGNORE_GENDER_QUERY_PARAM,
  IGNORE_COLOR_QUERY_PARAM,
  SEARCH_TERM_TYPO_SUGGESTIONS_DECISIONS,
};
